import { ClientError } from '#shared/services/api/middleware'

export function errorMessage(e: unknown): string {
  if (e instanceof Error) return e.message
  return 'Unknown error'
}

function validationMessages(errors: unknown): string {
  if (!errors || typeof errors !== 'object') return ''

  return Object.values(errors as Record<string, unknown>)
    .flatMap((entry) => (Array.isArray(entry) ? entry : [entry]))
    .filter((entry): entry is string => typeof entry === 'string' && entry.trim().length > 0)
    .join(' ')
}

export function messageFrom(error: unknown, fallback: string): string {
  if (error instanceof ClientError) {
    const body = error.body
    if (typeof body === 'string' && body.trim()) return body
    if (body && typeof body === 'object') {
      const obj = body as Record<string, unknown>

      const validation = validationMessages(obj.errors)
      if (validation) return validation

      // `error` is data-ingestion's `{ error: "…" }`, the shape its upload refusals take.
      const message = obj.detail ?? obj.title ?? obj.message ?? obj.reason ?? obj.error
      if (typeof message === 'string' && message.trim()) return message
    }
  }
  return fallback
}

export function isStaleChunk(error: unknown): boolean {
  return (
    error instanceof Error &&
    /dynamically imported module|Importing a module script failed|error loading dynamically imported module/i.test(
      error.message,
    )
  )
}

export function isClientError(error: unknown): boolean {
  return error instanceof ClientError && error.statusCode >= 400 && error.statusCode < 500
}

export function isNotFound(error: unknown): boolean {
  return error instanceof ClientError && error.statusCode === 404
}

export function isConflict(error: unknown): boolean {
  return error instanceof ClientError && (error.statusCode === 409 || error.statusCode === 412)
}
